import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const proximityToolSelector = (state: AppState) => state.frontendState.proximityTool;
export const useProximityToolSelector = () => useSelector(proximityToolSelector);

export const proximityToolDnDIsActiveSelector = (state: AppState) => state.frontendState.proximityTool.proximityIdInDnDMode !== null;
export const useProximityToolDnDIsActiveSelector = () => useSelector(proximityToolDnDIsActiveSelector);

export const proximityToolExportsSelector = (state: AppState) => state.frontendState.proximityTool.exports;
export const useProximityToolExportsSelector = () => useSelector(proximityToolExportsSelector);
